/* eslint-disable import/prefer-default-export */
import axios from "axios";
import gql from "graphql-tag";
import awsconfig from "../../awsconfig";
import getMaintenanceMode from "../../utilities";

const graphql = require("graphql");

const { print } = graphql;

interface SessionDetails {
  correlationId: string;
  brand: string;
  country: string;
  source: string;
  language: string;
}

interface Payload {
  partyId: number;
  loginAuthenticatorCode: string;
  sessionDetails: SessionDetails;
}

const gqlRequest = gql`
  mutation GenerateCustomerAuthenticatorSecret(
    $Request: GenerateCustomerAuthenticatorSecretRequest!
  ) {
    generateCustomerAuthenticatorSecret(Request: $Request) {
      IsSuccess
      Errors {
        ErrorCode
        ErrorMessage
        ErrorStack
      }
      SecretURI
      Secret
      LoginAttemptCount
    }
  }
`;

export const generateAuthenticatorSecret = async (payload: Payload) => {
  const { partyId, sessionDetails, loginAuthenticatorCode } = payload;
  try {
    const getMode = await getMaintenanceMode();
    if (getMode === true) {
      return {
        data: {
          inMaintenance: "Y",
        },
      };
    }
    const request = {
      PartyId: partyId,
      CorrelationId: sessionDetails.correlationId,
      Brand: sessionDetails.brand,
      SourceApp: sessionDetails.source,
      Country: sessionDetails.country,
      ParentFunctionName: "Generate Secret",
      ProcessName: "Generate Secret",
      WidgetName: sessionDetails.source,
      LoginAuthenticatorCode: loginAuthenticatorCode,
    };
    const response = await axios({
      url: awsconfig.aws_appsync_graphqlEndpoint,
      method: "post",
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
      data: {
        query: print(gqlRequest),
        variables: {
          Request: request,
        },
      },
    });
    if (response?.data?.data?.generateCustomerAuthenticatorSecret?.IsSuccess) {
      return {
        data: {
          isSuccess: true,
          secretURI:
            response?.data?.data?.generateCustomerAuthenticatorSecret
              ?.SecretURI,
          secret:
            response?.data?.data?.generateCustomerAuthenticatorSecret?.Secret,
          loginAttemptCount:
            response?.data?.data?.generateCustomerAuthenticatorSecret
              ?.LoginAttemptCount,
        },
      };
    }
    if (
      !response?.data?.data?.generateCustomerAuthenticatorSecret?.IsSuccess ||
      response?.data?.data === null
    ) {
      return {
        data: {
          isSuccess: false,
          errors:
            response?.data?.data?.generateCustomerAuthenticatorSecret
              ?.Errors?.[0] || response?.data?.errors,
        },
      };
    }
    return {
      data: {
        isSuccess: false,
        error: response?.data?.errors || response?.data || response,
      },
    };
  } catch (error) {
    return { error: error.message || error.toString() };
  }
};
